import React from "react";
import BannerBreadcrumb from "../Components/BannerBreadcrumb";

const StudentTestimonials = () => {
    const successtory = [
        {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "Pankaj Sinha",
            storyinsubject: "Master in Data Science"
        },
        {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "Rashmi Pandey",
            storyinsubject: "Master in Data Science"
        },
        {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "Adasrh Pandey",
            storyinsubject: "Master in Data Science"
        }, {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "DilKhush",
            storyinsubject: "Master in Data Science"
        }, {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "Pawan Patil",
            storyinsubject: "Master in Data Science"
        },
        {
            storylink: "https://www.youtube.com/embed/LO49IxE7QkI?si=D1izaoC14Ifs4snS",
            storywinner: "Rakesh Sachan",
            storyinsubject: "Master in Data Science"
        }
    ]
    return (
        <>
            <BannerBreadcrumb head={"Student Testimonials"} pagename={"Student Testimonials"} />
            <div className="container mt-5 mb-5 loan-eligibility">
                <h5 className="about-head text-center">Success Stories</h5>
                <div className="row">
                    {successtory.map((item, index) => (
                        <div className="col-md-4">
                            <div className="scholar-card">
                                <iframe className="successstory" src={item.storylink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                <h6 className="subhead mt-3">{item.storywinner}</h6>
                                <p className="loan-elegibility-des mt-0 mb-0">{item.storyinsubject}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default StudentTestimonials;